import React, { useCallback, useRef } from 'react'
import { Group } from 'three'

import DeviceShowcase from './DeviceShowcase'
import Project from 'components/Projects/Project'
import Container from 'components/Container'

import { PortfolioContainer, ProjectContainer } from './styled'

import { useProjects } from 'hooks/projects/useProjects'
import LoadingState from './LoadingState'

export default function Portfolio() {
  const projectDeviceRefs = useRef<Group[] | null[]>([])
  const portfolioContainerRef = useRef<HTMLElement>(null)

  const { projects } = useProjects({
    queryKey: 'portfolio-projects',
    apiParams: { expand: 'stats' },
  })

  const setProjectDeviceRef = useCallback((index: number, element: Group | null) => {
    projectDeviceRefs.current[index] = element
  }, [])

  return (
    <>
      {projects.length > 0 ? (
        <PortfolioContainer ref={portfolioContainerRef}>
          <Container sx={{ height: '100%' }}>
            {projects.map((project, index) => (
              <ProjectContainer key={index}>
                <Project hideCarouselControls project={project} portfolio />
              </ProjectContainer>
            ))}
          </Container>

          <DeviceShowcase
            projects={projects}
            portfolioContainerRef={portfolioContainerRef}
            projectDeviceRefs={projectDeviceRefs}
            setProjectDeviceRef={setProjectDeviceRef}
          />
        </PortfolioContainer>
      ) : (
        <LoadingState />
      )}
    </>
  )
}
